import React from 'react';
import { IParentComponent } from '../interfaces/IParentComponent';
import classNames from 'classnames';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';

export const BodyTextTW: React.FC<IParentComponent<HTMLDivElement>> = ({ children, className, ...rest }) => {
  return (
    <div
      className={classNames('text-sm/6 font-normal', className)}
      data-test-id={mergeTests(rest['data-test-id'], 'body-text-tw')}
      data-test-class={mergeTests(rest['data-test-class'], 'body-text-tw')}
      {...rest}
    >
      {children}
    </div>
  );
};

export const BoldBodyTextTW: React.FC<IParentComponent<HTMLDivElement>> = ({ children, className, ...rest }) => {
  return (
    <div
      className={classNames('text-sm/6 font-bold', className)}
      data-test-id={mergeTests(rest['data-test-id'], 'bold-body-text-tw')}
      data-test-class={mergeTests(rest['data-test-class'], 'bold-body-text-tw')}
    >
      {children}
    </div>
  );
};
